(() => {
  const root = document.querySelector('[data-plan-root]');
  if (!root) return;

  const escapeHtml = (value) => String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  let checkoutConfig = {};
  try {
    checkoutConfig = JSON.parse(root.querySelector('[data-plan-checkout-config]')?.textContent || '{}');
  } catch {
    checkoutConfig = {};
  }

  let imageUrls = {};
  try {
    imageUrls = JSON.parse(document.querySelector('[data-essenca-scent-images]')?.textContent || '{}');
  } catch {
    imageUrls = {};
  }

  const SCENTS = [
    { id: 'lc', theme: 'Laundry', name: 'Clean Air', color: '#A8C8DD', colorDark: '#547E9D', desc: 'Sun-dried linens lifted by a coastal breeze, clean, airy, and unmistakably fresh.', top: 'Aldehydes, citrus', heart: 'Cotton flower, lily of the valley', base: 'White musk, soft woods', mood: ['Fresh', 'Crisp', 'Clean'], pair: 'Pairs with White Tea for a spa-like morning ritual.',
    ingredients: 'Cottonseed extract, aldehyde accord, bergamot oil, white musk base'
    },
    { id: 'll', theme: 'Laundry', name: 'Citrus Clean', color: '#D8E0E8', colorDark: '#718397', desc: 'White musk and light florals layered on warm cotton. Quiet comfort for slow mornings.', top: 'Bergamot, pink pepper', heart: 'Iris, violet, white tea', base: 'Cashmere musk, cedar', mood: ['Soft', 'Cozy', 'Quiet'], pair: 'Layers with Vanilla Bean for a cashmere-warm afternoon.',
    ingredients: 'Iris root absolute, violet leaf, white tea distillate, cashmere musk'
    },
    { id: 'ls', theme: 'Laundry', name: 'Laundry Day', color: '#7FA8C0', colorDark: '#3E6E8A', desc: 'Ozone and driftwood carry coastal air through your space, fresh without florals.', top: 'Sea salt, ozone', heart: 'Driftwood, eucalyptus', base: 'Ambergris, vetiver', mood: ['Airy', 'Crisp', 'Coastal'], pair: 'Combines with Coastal Sage for a beachfront suite.',
    ingredients: 'Sea salt accord, ozone molecule, driftwood extract, vetiver oil'
    },
    { id: 'bv', theme: 'Bakery', name: 'Sugar Cookie', color: '#E5C8A0', colorDark: '#8B672A', desc: 'Madagascar vanilla pods steeped in warm cream, with the depth of a Parisian patisserie.', top: 'Sugar cane, anise', heart: 'Madagascar vanilla, cream', base: 'Benzoin, tonka bean', mood: ['Sweet', 'Warm', 'Indulgent'], pair: 'Deepens Tonka and Smoke for dessert-forward evenings.',
    ingredients: 'Madagascar vanilla pods, cream accord, benzoin resin, tonka bean'
    },
    { id: 'bb', theme: 'Bakery', name: 'Vanilla Cake', color: '#D4A574', colorDark: '#805A2A', desc: 'Warm butter, baked dough, and toasted sugar. The morning bakery before anyone else arrives.', top: 'Butterscotch, toasted sugar', heart: 'Brioche, warm milk', base: 'Sandalwood, brown sugar', mood: ['Comforting', 'Warm', 'Nostalgic'], pair: 'Complements Vanilla Bean in a kitchen setting.',
    ingredients: 'Toasted sugar accord, brioche note, warm milk, sandalwood oil'
    },
    { id: 'bc', theme: 'Bakery', name: 'Snickerdoodle', color: '#C89464', colorDark: '#73451F', desc: 'Slow-pour caramel over toasted hazelnut. Rich without weight and sweet without cloying.', top: 'Salted caramel', heart: 'Hazelnut, praline', base: 'Amber, vanilla absolute', mood: ['Rich', 'Sweet', 'Decadent'], pair: 'Resonates with Tonka and Smoke for a fireside mood.',
    ingredients: 'Salted caramel accord, hazelnut extract, praline, vanilla absolute'
    },
    { id: 'hv', theme: 'Her Era', name: 'Her Secret', color: '#C89098', colorDark: '#854149', desc: 'Bulgarian rose petals settle into velvet musk for a romantic, cinematic floral.', top: 'Pink pepper, litchi', heart: 'Bulgarian rose, peony', base: 'Velvet musk, sandalwood', mood: ['Romantic', 'Sensual', 'Floral'], pair: 'Elevates Silk Powder into a soft evening signature.',
    ingredients: 'Bulgarian rose absolute, peony extract, velvet musk, sandalwood'
    },
    { id: 'hs', theme: 'Her Era', name: 'Beautiful Life', color: '#E0C8C8', colorDark: '#896173', desc: 'Powdered iris and violet over fresh linen, with the softness of vintage silk.', top: 'Aldehydes, bergamot', heart: 'Iris, violet, heliotrope', base: 'White musk, powdered sandalwood', mood: ['Soft', 'Nostalgic', 'Calm'], pair: 'Amplifies Velvet Rose with a powder-soft finish.',
    ingredients: 'Iris butter, violet, heliotrope, powdered sandalwood'
    },
    { id: 'hp', theme: 'Her Era', name: 'Perfect', color: '#E8B4C0', colorDark: '#9D5764', desc: 'A bouquet of just-cut peonies in dewy morning air, floral without powder.', top: 'Green leaves, pear', heart: 'Peony, jasmine, magnolia', base: 'Soft musk, blonde woods', mood: ['Bright', 'Floral', 'Joyful'], pair: 'Pairs with White Tea for a garden-party feel.',
    ingredients: 'Green leaf accord, pear nectar, jasmine, blonde woods'
    },
    { id: 'go', theme: 'Island Cabana', name: 'Island Life', color: '#7A5A3C', colorDark: '#3D2816', desc: 'Smoky oud, saffron threads, and leather create a deep, resinous evening signature.', top: 'Saffron, pink pepper', heart: 'Oud, rose absolute', base: 'Leather, patchouli, amber', mood: ['Bold', 'Smoky', 'Luxurious'], pair: 'Complements Tonka and Smoke in a library setting.',
    ingredients: 'Saffron threads, oud oil, leather accord, patchouli, amber'
    },
    { id: 'gt', theme: 'Island Cabana', name: 'Piña Colada', color: '#5C3E2C', colorDark: '#2E1B11', desc: 'Smoldering tonka bean wrapped in birchwood smoke, intimate and lasting.', top: 'Birch tar, smoke', heart: 'Tonka bean, tobacco leaf', base: 'Vetiver, leather, oud', mood: ['Smoky', 'Warm', 'Cinematic'], pair: 'Layers with Oud and Saffron for more depth.',
    ingredients: 'Birch tar, tonka bean, tobacco leaf, vetiver, leather'
    },
    { id: 'gl', theme: 'Island Cabana', name: 'Ocean Breeze', color: '#6C4C3C', colorDark: '#342218', desc: 'Ripe fig leaves, suede leather, and sun-warmed wood form a refined Mediterranean signature.', top: 'Fig leaf, bergamot', heart: 'Suede, fig nectar', base: 'Cedar, smoke, musk', mood: ['Refined', 'Earthy', 'Mediterranean'], pair: 'Pairs with Tonka and Smoke for autumn evenings.',
    ingredients: 'Fig leaf, fig nectar, suede accord, cedar, soft smoke'
    },
    { id: 'fj', theme: 'Floral', name: 'Jasmine', color: '#D8C8E0', colorDark: '#775F8E', desc: 'Night-blooming jasmine wrapped in dark musk. This is the floral after sundown.', top: 'Neroli, green notes', heart: 'Jasmine sambac, tuberose', base: 'White musk, vetiver', mood: ['Intoxicating', 'Sensual', 'Nocturnal'], pair: 'Complements Velvet Rose in a romantic suite.',
    ingredients: 'Neroli oil, jasmine sambac, tuberose, white musk'
    },
    { id: 'fl', theme: 'Floral', name: 'Gardenia', color: '#B8C8A8', colorDark: '#5E7548', desc: 'White lily and aromatic sage, like fresh herbs washed by morning light.', top: 'Sage, eucalyptus', heart: 'White lily, neroli', base: 'White musk, vetiver', mood: ['Herbal', 'Fresh', 'Botanical'], pair: 'Pairs with White Tea for a clean-skin feel.',
    ingredients: 'Sage oil, eucalyptus, white lily, neroli, vetiver'
    },
    { id: 'fo', theme: 'Floral', name: "Monet's Garden", color: '#E8D8D8', colorDark: '#8A6666', desc: 'Southern magnolia petals with citrus dew, creamy and bright.', top: 'Lemon zest, pear', heart: 'Magnolia, ylang-ylang', base: 'Sandalwood, soft musk', mood: ['Creamy', 'Bright', 'Spring'], pair: 'Layers with Peony Bloom for a spring garden.',
    ingredients: 'Lemon zest, magnolia absolute, ylang-ylang, sandalwood'
    },
    { id: 'ew', theme: 'Everyday', name: 'Peppermint', color: '#E8E4D8', colorDark: '#77715E', desc: 'Steeped white tea leaves, soft citrus, and sheer musk create an easy daily neutral.', top: 'Bergamot, lemon zest', heart: 'White tea, bamboo', base: 'Sheer musk, light woods', mood: ['Clean', 'Neutral', 'Daily'], pair: 'A versatile pairing choice for any theme.',
    ingredients: 'White tea leaf, bamboo extract, bergamot, sheer musk'
    },
    { id: 'ec', theme: 'Everyday', name: 'Lavender', color: '#9CB89C', colorDark: '#496B49', desc: 'Wild sage, sea air, and eucalyptus make a clean neutral for open-plan rooms.', top: 'Sea air, eucalyptus', heart: 'Sage, rosemary', base: 'Driftwood, white musk', mood: ['Herbal', 'Clean', 'Coastal'], pair: 'Pairs with Sea Salt Breeze for an oceanfront mood.',
    ingredients: 'Wild sage, rosemary oil, driftwood, sea-air accord'
    },
    { id: 'eo', theme: 'Everyday', name: 'Eucalyptus', color: '#DCC8A4', colorDark: '#7D6238', desc: 'Warm oat milk and wildflower honey feel neutral, sweet, and comforting.', top: 'Honeycomb, almond', heart: 'Oat milk, vanilla', base: 'Soft amber, cashmere musk', mood: ['Neutral', 'Sweet', 'Cozy'], pair: 'Pairs with Vanilla Bean for a warm kitchen mood.',
    ingredients: 'Honeycomb accord, almond oil, oat milk, vanilla, amber' }
  ];

  const DURATIONS = {
    1: { name: '1-Month Starter', device: 39.9, deviceLabel: '$39.90 device', contract: true, weeks: 4 },
    3: { name: '3-Month Plan', device: 39.9, deviceLabel: '$39.90 device', contract: true, weeks: 12 },
    6: { name: '6-Month Plan', device: 39.9, deviceLabel: '$39.90 device', contract: true, weeks: 24 },
    12: { name: '1-Year Home', device: 39.9, deviceLabel: '$39.90 device', contract: true, weeks: 52 }
  };

  const RHYTHMS = {
    2: { price: 19.90, label: 'Every 2 weeks' },
    4: { price: 19.90, label: 'Every 4 weeks' },
    6: { price: 19.90, label: 'Every 6 weeks' }
  };

  const PRESETS = {
    1: { name: 'Starter rotation', desc: 'Your chosen pair for every delivery.', pairs: [['ew', 'lc']] },
    3: { name: '3-Month Curated Rotation', desc: 'Fresh, bakery, and floral moods.', pairs: [['lc', 'ew'], ['bb', 'bv'], ['hv', 'hp']] },
    6: { name: '6-Month Curated Rotation', desc: 'Fresh, floral, bakery, coastal, soft, and evening moods.', pairs: [['lc', 'ew'], ['hp', 'fj'], ['bb', 'bv'], ['ec', 'ls'], ['hv', 'hs'], ['go', 'gt']] }
    ,12: { name: '1-Year Curated Rotation', desc: 'A full year of fresh scent rotations.', pairs: [['lc', 'ew']] }
  };

  const STORAGE_KEY = 'essenca-scentplan-v3';
  const initialState = {
    duration: 6,
    weeks: 4,
    oneTime: false,
    kit: null,
    scents: [],
    schedule: [],
    mode: 'same',
    presetApplied: false,
    step: 'scents',
    advancedOpen: false,
    scheduleWarning: false,
    planConfirmed: false,
    message: 'Choose one ScentKit to begin.',
    addedSignature: null,
    demoComplete: false
  };

  const restoreState = () => {
    try {
      const saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
      if (!saved || typeof saved !== 'object') return { ...initialState };
      const restored = { ...initialState, ...saved };
      restored.duration = DURATIONS[restored.duration] ? Number(restored.duration) : 6;
      restored.weeks = RHYTHMS[restored.weeks] ? Number(restored.weeks) : 4;
      restored.oneTime = false;
      restored.kit = SCENTS.some((s) => s.theme === restored.kit) ? restored.kit : null;
      restored.scents = Array.isArray(restored.scents)
        ? restored.scents.filter((id) => SCENTS.some((scent) => scent.id === id)).slice(0, 3)
        : [];
      if (restored.kit && restored.scents.length !== 3) restored.scents = SCENTS.filter((s) => s.theme === restored.kit).map((s) => s.id);
      if (!restored.kit) restored.scents = [];
      restored.schedule = Array.isArray(restored.schedule) ? restored.schedule : [];
      restored.step = ['scents', 'plan', 'review'].includes(restored.step) ? restored.step : 'scents';
      if (!restored.kit) restored.step = 'scents';
      if (restored.step === 'review' && !restored.planConfirmed) restored.step = 'plan';
      return restored;
    } catch {
      return { ...initialState, message: 'Your previous plan could not be restored. Start by choosing one ScentKit.' };
    }
  };

  const state = restoreState();
  // Future-scent personalization is not offered in the current storefront.
  // Normalize previously saved sessions so every delivery repeats the selected kit.
  Object.assign(state, {
    mode: 'same',
    schedule: [],
    presetApplied: false,
    advancedOpen: false,
    scheduleWarning: false
  });
  const qs = (selector, context = root) => context?.querySelector(selector);
  const qsa = (selector, context = root) => Array.from(context?.querySelectorAll(selector) || []);
  // Keep the complete modal implementation below, but leave the public entry
  // point disabled until every individual oil has its own approved image.
  const scentDetailsEnabled = false;
  const scentHelp = qs('.plan-scent-help');
  if (scentHelp) scentHelp.textContent = 'Choose one ScentKit. Tap anywhere on a card to select it.';
  const scentById = (id) => SCENTS.find((scent) => scent.id === id);
  const pairComplete = (pair) => Array.isArray(pair) && pair.length >= 3 && pair.every((id) => Boolean(id));
  const deliveryCount = () => {
    if (state.oneTime) return 1;
    // The one-month starter includes the free Refill shipped today and the
    // first paid renewal at Week 4. Longer plans retain their existing count.
    if (state.duration === 1 && state.weeks === 4) return 2;
    return Math.max(1, Math.ceil(DURATIONS[state.duration].weeks / state.weeks));
  };
  const rewardFor = () => ({ 3: '$9.90 cash back', 6: '$19.90 cash back + 1 free Refill', 12: '$29.90 cash back + 3 free Refills' }[state.duration] || '');
  const deliveryLabel = (index) => index === 0 ? 'Today' : `Week ${index * state.weeks}`;
  const kitPrice = RHYTHMS[4].price;

  const checkoutReady = () => Boolean(checkoutConfig.starterVariantId && checkoutConfig.refillVariants?.[state.kit]?.id && checkoutConfig.refillVariants?.[state.kit]?.available && (state.oneTime || checkoutConfig.sellingPlans?.[`${state.duration}-${state.weeks}`]));

  const startCheckout = async (trigger) => {
    const error = qs('[data-plan-checkout-error]');
    if (error) {
      error.hidden = true;
      error.textContent = '';
    }
    if (!checkoutReady()) {
      if (error) {
        error.textContent = 'This plan is temporarily unavailable. Please choose another option or try again.';
        error.hidden = false;
      }
      return;
    }

    // Shopify renders theme previews inside a cross-origin iframe. Open the
    // checkout tab immediately while the click still has user activation;
    // navigating window.top after the async cart requests is blocked by the
    // browser even when the items were added successfully.
    const embeddedPreview = window.top !== window.self;
    let checkoutWindow = null;
    if (embeddedPreview) {
      try {
        const previewCartUrl = new URL('/cart', window.location.origin);
        const currentParams = new URLSearchParams(window.location.search);
        for (const parameter of ['_ab', '_fd', '_sc', 'key', 'preview_theme_id']) {
          const value = currentParams.get(parameter);
          if (value) previewCartUrl.searchParams.set(parameter, value);
        }
        checkoutWindow = window.open(previewCartUrl.toString(), 'essenca-secure-checkout');
      } catch (popupError) {
        checkoutWindow = null;
      }
    }

    const primary = qs('[data-plan-primary-cta]');
    primary.disabled = true;
    primary.setAttribute('aria-busy', 'true');
    const refill = checkoutConfig.refillVariants[state.kit];
    const planId = checkoutConfig.sellingPlans[`${state.duration}-${state.weeks}`];
    const names = state.scents.map((id) => scentById(id)?.name).filter(Boolean).join(' · ');
    const code = state.oneTime ? checkoutConfig.discountCodes?.oneTime : '';
    const properties = {
      ScentKit: state.kit,
      Commitment: `${state.duration} month${state.duration === 1 ? '' : 's'}`,
      'Delivery rhythm': `Every ${state.weeks} weeks`,
      'Scent selection': names,
      'Reward': state.oneTime ? 'None — one-time purchase' : rewardFor(),
      'Reward timing': state.oneTime ? 'Not applicable' : 'Eligible after the final scheduled charge',
    };
    if (state.mode === 'custom' && state.schedule.length) {
      properties['Future scent schedule'] = state.schedule.map((pair, index) => `Delivery ${index + 1}: ${formatPair(pair)}`).join(' | ');
    }

    try {
      if (embeddedPreview && !checkoutWindow) {
        throw new Error('Checkout window was blocked by the browser');
      }

      // Keep every cart request inside the storefront iframe, where Shopify's
      // preview cookies and same-origin access are available. The new window is
      // only a navigation target; reading or calling methods on it can fail as
      // soon as Shopify moves it to the canonical storefront domain.
      const storefrontFetch = (path, options = {}) => window.fetch(
        new URL(path, window.location.origin).toString(),
        { credentials: 'same-origin', ...options },
      );

      // Replace only the ONE/Refill lines owned by this configurator. This
      // prevents Shopify's max-quantity guard when a preview cart has a
      // previous test configuration, while preserving unrelated cart items.
      const cartResponse = await storefrontFetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error(`Cart read failed with ${cartResponse.status}`);
      const cart = await cartResponse.json();
      const managedVariantIds = new Set([
        Number(checkoutConfig.starterVariantId),
        ...Object.values(checkoutConfig.refillVariants || {}).map((variant) => Number(variant?.id)),
      ]);
      const managedItems = (cart.items || []).filter((item) => managedVariantIds.has(Number(item.variant_id)));
      for (const item of managedItems) {
        const changeResponse = await storefrontFetch('/cart/change.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 }),
        });
        if (!changeResponse.ok) throw new Error(`Cart cleanup failed with ${changeResponse.status}`);
      }
      const response = await storefrontFetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: checkoutConfig.starterVariantId,
              quantity: 1,
              properties: { ...properties, 'Purchase type': 'Essénca ONE starter device' },
            },
            {
              id: refill.id,
              quantity: 1,
              ...(state.oneTime ? {} : { selling_plan: planId }),
              properties: { ...properties, 'Purchase type': 'ScentPod + essential oil refill subscription' },
            },
          ],
        }),
      });
      if (!response.ok) {
        let detail = '';
        try { detail = (await response.json()).description || ''; } catch (e) {}
        throw new Error(`Cart add failed with ${response.status}${detail ? `: ${detail}` : ''}`);
      }
      const redirect = new URL(code ? `/discount/${encodeURIComponent(code)}` : (checkoutConfig.checkoutPath || '/checkout'), window.location.origin);
      if (code) redirect.searchParams.set('redirect', checkoutConfig.checkoutPath || '/checkout');
      const checkoutUrl = redirect.toString();
      if (embeddedPreview) {
        if (!checkoutWindow) throw new Error('Checkout window was blocked by the browser');
        // A cross-origin WindowProxy allows navigation through the href setter,
        // but location.replace() is not guaranteed to be callable.
        checkoutWindow.location.href = checkoutUrl;
      } else {
        window.location.assign(checkoutUrl);
      }
    } catch (checkoutError) {
      console.error('[Essenca] Could not start real subscription checkout.', checkoutError);
      if (checkoutWindow && !checkoutWindow.closed) checkoutWindow.close();
      if (error) {
        if (checkoutError.message.includes('blocked by the browser')) {
          error.textContent = 'Your browser blocked the checkout window. Allow pop-ups for this preview, then try again.';
        } else {
          error.textContent = 'We could not start secure checkout. Please try again.';
        }
        error.hidden = false;
      }
      primary.disabled = false;
      primary.removeAttribute('aria-busy');
      if (trigger) trigger.focus();
    }
  };

  const persist = () => {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch {
      state.message = 'Your choices are active, but this browser could not save them for refresh.';
    }
  };

  const resizeSchedule = () => {
    const size = deliveryCount();
    while (state.schedule.length < size) state.schedule.push(null);
    state.schedule.length = size;
  };

  const customFilledCount = () => {
    resizeSchedule();
    return state.schedule.filter(pairComplete).length;
  };

  const readyForReview = () => Boolean(state.kit)
    && (state.mode === 'same' || customFilledCount() === deliveryCount());

  const configurationSignature = () => JSON.stringify({
    duration: state.duration,
    weeks: state.weeks,
    oneTime: state.oneTime,
    mode: state.mode,
    scents: [...state.scents],
    schedule: state.mode === 'custom'
      ? state.schedule.slice(0, deliveryCount()).map((pair) => Array.isArray(pair) ? [...pair] : null)
      : []
  });

  const invalidateAddedPlan = () => {
    if (state.addedSignature && state.addedSignature !== configurationSignature()) {
      state.addedSignature = null;
      state.demoComplete = false;
    }
  };

  const formatPair = (pair) => pairComplete(pair)
    ? pair.map((id) => scentById(id).name).join(' + ')
    : 'Choose a ScentKit';

  const setCurrentStep = (step, moveFocus = false) => {
    if (step === 'plan' && !state.kit) return;
    if (step === 'review' && (!readyForReview() || !state.planConfirmed)) return;
    state.step = step;
    state.message = step === 'scents'
      ? 'Your scent choices are saved.'
      : step === 'plan'
        ? 'Confirm your commitment and delivery rhythm.'
        : 'Review your complete plan before secure Shopify checkout.';
    refreshAll();
    if (moveFocus) {
      qs(`[data-plan-go-step="${step}"]`)?.focus();
      qs(`[data-plan-step-panel="${step}"]`)?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }
  };

  const updatePressedState = () => {
    qsa('[data-plan-duration]').forEach((button) => {
      const selected = Number(button.dataset.planDuration) === state.duration;
      button.classList.toggle('selected', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    qsa('[data-plan-weeks]').forEach((button) => {
      const selected = !state.oneTime && Number(button.dataset.planWeeks) === state.weeks;
      button.classList.toggle('selected', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    qsa('[data-plan-mode]').forEach((button) => {
      const selected = button.dataset.planMode === state.mode;
      button.classList.toggle('active', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    qsa('[data-plan-theme]').forEach((button) => {
      const selected = button.dataset.planTheme === state.kit;
      button.classList.toggle('active', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    qsa('[data-plan-package]').forEach((button) => {
      const selected = button.dataset.planPackage === state.package;
      button.classList.toggle('selected', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
  };

  const renderProgress = () => {
    root.dataset.currentStep = state.step;
    qsa('[data-plan-step-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.planStepPanel !== state.step;
    });
    qsa('[data-plan-go-step]').forEach((button) => {
      const target = button.dataset.planGoStep;
      const enabled = target === 'scents' || (target === 'plan' && state.kit) || (target === 'review' && readyForReview() && state.planConfirmed);
      button.disabled = !enabled;
      button.classList.toggle('active', target === state.step);
      if (target === state.step) button.setAttribute('aria-current', 'step');
      else button.removeAttribute('aria-current');
      button.closest('li')?.classList.toggle('complete', target === 'scents' ? Boolean(state.kit) : target === 'plan' && state.planConfirmed);
    });
  };

  const selectKit = (theme) => {
    const kitScents = SCENTS.filter((s) => s.theme === theme);
    if (!kitScents.length) return;
    if (state.kit === theme) {
      state.kit = null;
      state.scents = [];
      state.message = 'Kit removed. Choose one ScentKit to continue.';
    } else {
      state.kit = theme;
      state.scents = kitScents.map((s) => s.id);
      state.message = `${theme} kit selected. Three essential oils and three ScentPods ship every delivery.`;
    }
    state.mode = 'same';
    state.planConfirmed = false;
    state.presetApplied = false;
    state.schedule = [];
    invalidateAddedPlan();
    refreshAll();
  };

  const renderScents = () => {
    const grid = qs('[data-plan-scent-grid]');
    if (!grid) return;
    const kits = [];
    SCENTS.forEach((scent) => { if (!kits.includes(scent.theme)) kits.push(scent.theme); });
    grid.innerHTML = kits.map((theme) => {
      const members = SCENTS.filter((s) => s.theme === theme);
      const selected = state.kit === theme;
      const swatches = members.map((s) => `<span class="plan-kit-swatch" style="background:${s.color}" aria-hidden="true" title="${s.name}"></span>`).join('');
      const names = members.map((s) => s.name).join(' · ');
      const image = imageUrls[members[0].id] || '';
      const detailsControl = scentDetailsEnabled ? `
          <span class="plan-kit-card-foot">
            <button type="button" class="plan-kit-expand" data-plan-kit-expand="${escapeHtml(theme)}" aria-haspopup="dialog" aria-label="Open ${escapeHtml(theme)} scent notes">
              <span class="plan-kit-expand-dot" aria-hidden="true"></span>
              <span>Scent notes</span>
              <span aria-hidden="true">↗</span>
            </button>
          </span>` : '';
      return `
        <article class="plan-scent-card plan-kit-card ${selected ? 'selected' : ''}" data-plan-kit-card="${escapeHtml(theme)}" tabindex="0" aria-label="${escapeHtml(theme)} ScentKit. ${selected ? 'Selected.' : 'Click to select.'}" style="--scent-light:${members[0].color};--scent-dark:${members[0].colorDark}">
          <span class="plan-kit-image"><img src="${escapeHtml(image)}" alt="${escapeHtml(theme)} ScentKit" loading="lazy" width="800" height="1000"></span>
          <span class="plan-kit-swatches" aria-hidden="true">${swatches}</span>
          <strong class="plan-kit-title">${escapeHtml(theme)}</strong>
          <span class="plan-kit-names">${names}</span>
          ${detailsControl}
        </article>`;
    }).join('');
  };

  // The card selects on any click; the subtle footer affordance is reserved for details.
  const scentGrid = qs('[data-plan-scent-grid]');
  scentGrid?.addEventListener('click', (event) => {
    const expand = event.target.closest('[data-plan-kit-expand]');
    if (scentDetailsEnabled && expand) {
      event.preventDefault();
      event.stopPropagation();
      openKitDialog(expand.dataset.planKitExpand, expand);
      return;
    }
    const card = event.target.closest('[data-plan-kit-card]');
    if (card) selectKit(card.dataset.planKitCard);
  });

  scentGrid?.addEventListener('keydown', (event) => {
    const card = event.target.closest('[data-plan-kit-card]');
    if (!card || event.target.closest('[data-plan-kit-expand]')) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    selectKit(card.dataset.planKitCard);
  });

  const renderTimeline = () => {
    const timeline = qs('[data-plan-timeline]');
    if (!timeline) return;
    const total = deliveryCount();
    const dots = Array.from({ length: total }, () => '<span class="plan-timeline-dot" aria-hidden="true"></span>').join('');
    const dates = Array.from({ length: total }, (_, index) => deliveryLabel(index)).join(', ');
    timeline.innerHTML = `<div class="plan-timeline-rail" aria-hidden="true"><div class="plan-timeline-dots">${dots}</div></div><div class="plan-timeline-summary">${total} deliveries. ${dates}.</div>`;
  };

  const renderPreset = () => {
    const wrap = qs('[data-plan-preset]');
    if (!wrap) return;
    const preset = PRESETS[state.duration];
    wrap.innerHTML = `
      <button type="button" class="plan-preset ${state.presetApplied ? 'selected' : ''}" data-plan-apply-preset aria-pressed="${state.presetApplied}">
        <span class="plan-preset-head"><span class="plan-preset-title">${preset.name}</span><span class="plan-preset-action">${state.presetApplied ? 'Applied' : 'Apply rotation'}</span></span>
        <span class="plan-preset-description">${preset.desc}</span>
      </button>`;
    qs('[data-plan-apply-preset]', wrap)?.addEventListener('click', applyPreset);
  };

  const renderSchedule = () => {
    const list = qs('[data-plan-schedule-list]');
    if (!list) return;
    resizeSchedule();
    list.innerHTML = state.schedule.map((pair, deliveryIndex) => {
      const safePair = Array.isArray(pair) ? pair : [null, null, null];
      const slots = [0, 1, 2].map((slotIndex) => {
        const scent = scentById(safePair[slotIndex]);
        return `<button type="button" class="plan-schedule-slot ${scent ? 'filled' : ''}" data-plan-slot data-delivery-index="${deliveryIndex}" data-slot-index="${slotIndex}" aria-label="Delivery ${deliveryIndex + 1}, bottle ${slotIndex + 1}, ${scent ? scent.name : 'choose scent'}">${scent ? `<span class="plan-slot-swatch" style="background:${scent.color}" aria-hidden="true"></span><span>${scent.name}</span>` : '<span>Choose scent</span>'}</button>`;
      }).join('');
      return `<div class="plan-schedule-row"><div class="plan-schedule-label"><strong>Delivery ${deliveryIndex + 1}</strong><span>${deliveryLabel(deliveryIndex)}</span></div><div class="plan-schedule-slots">${slots}</div>${deliveryIndex > 0 ? `<button type="button" class="plan-copy-previous" data-plan-copy-previous="${deliveryIndex}">Copy previous</button>` : ''}</div>`;
    }).join('');
    qsa('[data-plan-slot]', list).forEach((button) => button.addEventListener('click', () => openSlotDialog(Number(button.dataset.deliveryIndex), Number(button.dataset.slotIndex), button)));
    qsa('[data-plan-copy-previous]', list).forEach((button) => button.addEventListener('click', () => {
      const index = Number(button.dataset.planCopyPrevious);
      const previous = state.schedule[index - 1];
      if (!pairComplete(previous)) {
        state.message = `Complete Delivery ${index} before copying it.`;
      } else {
      state.schedule[index] = [...previous];
      state.presetApplied = false;
      state.planConfirmed = false;
        state.message = `Delivery ${index + 1} now matches Delivery ${index}.`;
      }
      invalidateAddedPlan();
      refreshAll();
    }));
  };

  function applyPreset() {
    const preset = PRESETS[state.duration];
    state.mode = 'custom';
    state.schedule = Array.from({ length: deliveryCount() }, () => [...state.scents]);
    state.presetApplied = true;
    state.planConfirmed = false;
    state.advancedOpen = true;
    state.scheduleWarning = false;
    state.message = `${preset.name} applied. Every delivery includes the ${state.kit} kit's three scents.`;
    invalidateAddedPlan();
    refreshAll();
  }

  const updateSummary = () => {
    const duration = DURATIONS[state.duration];
    const rhythm = RHYTHMS[state.weeks];
    const total = deliveryCount();
    const firstCharge = duration.device;
    const minimum = firstCharge + Math.max(0, total - 1) * rhythm.price;
    const ready = readyForReview();
    const scentSummary = state.mode === 'custom' && ready
      ? `${formatPair(state.scents)} · ${total} planned deliveries`
      : formatPair(state.scents);

    qs('[data-plan-summary-device]').textContent = duration.deviceLabel;
    qs('[data-plan-summary-scents]').textContent = scentSummary;
    qs('[data-plan-summary-plan]').textContent = state.oneTime ? 'One-time purchase' : duration.name;
    qs('[data-plan-summary-rhythm]').textContent = state.oneTime ? 'No recurring delivery' : rhythm.label;
    const reward = qs('[data-plan-summary-reward]');
    if (reward) reward.textContent = state.oneTime ? 'No subscription reward' : (rewardFor() || 'No cash-back reward');
    const futureLabel = qs('[data-plan-summary-future-label]');
    if (futureLabel) futureLabel.textContent = state.oneTime ? 'Includes' : 'Future charge';
    qs('[data-plan-summary-future]').textContent = state.oneTime ? 'ONE + 1 selected refill' : `$${rhythm.price.toFixed(2)} every ${state.weeks} weeks`;
    qs('[data-plan-summary-minimum]').textContent = state.oneTime ? '$39.90 paid once' : `$${minimum.toFixed(2)} minimum plan total`;
    qs('[data-plan-first-charge]').textContent = `$${firstCharge.toFixed(2)}`;
    qs('[data-plan-first-sub]').textContent = state.oneTime ? 'Essénca ONE plus your selected ScentKit refill. One-time payment, no subscription.' : `Essénca ONE plus your first Refill included today. Then $${rhythm.price.toFixed(2)} every ${state.weeks} weeks.`;

    const contract = qs('[data-plan-contract-note]');
    if (!state.oneTime && duration.contract) {
      contract.innerHTML = `<strong>${state.duration}-month commitment.</strong> Early cancellation may require repayment of the remaining device subsidy. Your next refill charge is in ${state.weeks} weeks.`;
      contract.classList.remove('no-contract');
    } else {
      contract.innerHTML = `<strong>No commitment.</strong> Pause or cancel before the next refill renewal in ${state.weeks} weeks.`;
      contract.classList.add('no-contract');
    }

    const count = qs('[data-plan-scent-count]');
    count.textContent = state.kit ? `${state.kit} kit · 3 scents` : '0 of 6 kits chosen';
    count.classList.toggle('ready', Boolean(state.kit));
    const primary = qs('[data-plan-primary-cta]');
    const status = qs('[data-plan-status]');
    const primarySummary = qs('[data-plan-primary-summary]');
    const showFloatingTotal = state.step !== 'scents' && ready;
    root.dataset.totalReady = String(showFloatingTotal);
    primarySummary.textContent = showFloatingTotal ? 'Total today' : '';

    if (state.step === 'scents') {
      primary.disabled = !state.kit;
      primary.textContent = state.kit ? 'Choose plan options' : 'Choose one ScentKit';
    } else if (state.step === 'plan') {
      primary.disabled = !ready;
      primary.textContent = ready ? 'Continue to review' : `Complete ${deliveryCount() - customFilledCount()} deliveries`;
    } else {
      primary.disabled = !ready || !checkoutReady();
      primary.textContent = ready ? (state.oneTime ? 'Buy ONE + refill · $39.90' : `Start my ScentPlan · $${firstCharge.toFixed(2)}`) : 'Complete your plan';
    }
    status.textContent = showFloatingTotal ? `$${firstCharge.toFixed(2)}` : state.message;
    status.classList.toggle('ready', ready);

    const checkoutError = qs('[data-plan-checkout-error]');
    if (checkoutError && checkoutReady() && checkoutError.textContent) {
      checkoutError.hidden = true;
      checkoutError.textContent = '';
    }
  };

  const refreshAll = () => {
    invalidateAddedPlan();
    updatePressedState();
    renderProgress();
    renderScents();
    renderTimeline();
    renderPreset();
    const customMode = qs('[data-plan-custom-mode]');
    if (customMode) customMode.hidden = state.mode !== 'custom';
    if (state.mode === 'custom') renderSchedule();
    const advanced = qs('[data-plan-advanced]');
    if (advanced && advanced.open !== state.advancedOpen) advanced.open = state.advancedOpen;
    const warning = qs('[data-plan-schedule-warning]');
    if (warning) warning.hidden = !state.scheduleWarning;
    updateSummary();
    persist();
  };

  qsa('[data-plan-go-step]').forEach((button) => button.addEventListener('click', () => setCurrentStep(button.dataset.planGoStep, true)));

  qsa('[data-plan-duration]').forEach((button) => button.addEventListener('click', () => {
    const next = Number(button.dataset.planDuration);
    if (next === state.duration) return;
    const hadSchedule = state.mode === 'custom' && state.schedule.some(pairComplete);
    state.duration = next;
    state.planConfirmed = false;
    state.scheduleWarning = hadSchedule;
    if (state.presetApplied) {
      applyPreset();
      state.scheduleWarning = hadSchedule;
      state.message = hadSchedule ? 'Plan changed. Review the updated future delivery schedule.' : 'Commitment updated. Review the pricing summary.';
      refreshAll();
    }
    else {
      resizeSchedule();
      state.message = hadSchedule ? 'Plan changed. Review the updated future delivery schedule.' : 'Commitment updated. Review the pricing summary.';
      invalidateAddedPlan();
      refreshAll();
    }
  }));

  qsa('[data-plan-weeks]').forEach((button) => button.addEventListener('click', () => {
    const next = Number(button.dataset.planWeeks);
    const hadSchedule = state.mode === 'custom' && state.schedule.some(pairComplete);
    state.oneTime = false;
    if (next === state.weeks) return;
    state.weeks = next;
    state.planConfirmed = false;
    state.scheduleWarning = hadSchedule;
    if (state.presetApplied) {
      applyPreset();
      state.scheduleWarning = hadSchedule;
      state.message = hadSchedule ? 'Delivery rhythm changed. Review the updated future schedule.' : 'Delivery rhythm updated.';
      refreshAll();
    }
    else {
      resizeSchedule();
      state.message = hadSchedule ? 'Delivery rhythm changed. Review the updated future schedule.' : 'Delivery rhythm updated.';
      invalidateAddedPlan();
      refreshAll();
    }
  }));

  qsa('[data-plan-one-time]').forEach((button) => button.addEventListener('click', () => {
    state.oneTime = true;
    state.planConfirmed = true;
    state.step = 'review';
    state.message = 'One-time purchase: Essénca ONE + one refill, $39.90 today. No subscription.';
    invalidateAddedPlan();
    refreshAll();
  }));

  const PACKAGE_PRESETS = {
    trial: { oneTime: true, duration: 1, weeks: 4 },
    starter: { oneTime: false, duration: 1, weeks: 4 },
    rhythm: { oneTime: false, duration: 3, weeks: 4 },
    owner: { oneTime: false, duration: 6, weeks: 4 },
    'always-on': { oneTime: false, duration: 12, weeks: 4 },
  };
  qsa('[data-plan-package]').forEach((button) => button.addEventListener('click', () => {
    const preset = PACKAGE_PRESETS[button.dataset.planPackage];
    if (!preset) return;
    Object.assign(state, preset, { package: button.dataset.planPackage, planConfirmed: false, step: 'plan', mode: 'same' });
    state.schedule = Array.from({ length: preset.oneTime ? 1 : deliveryCount() }, () => [...state.scents]);
    state.message = preset.oneTime ? 'One-time purchase selected. Review the included ONE + refill below.' : `${preset.duration}-month ScentPlan selected. Review your delivery schedule below.`;
    invalidateAddedPlan();
    refreshAll();
  }));

  qsa('[data-plan-mode]').forEach((button) => button.addEventListener('click', () => {
    const next = button.dataset.planMode;
    if (next === state.mode) return;
    state.mode = next;
    state.planConfirmed = false;
    state.presetApplied = false;
    state.scheduleWarning = false;
    if (next === 'custom') {
      resizeSchedule();
      state.schedule = state.schedule.map((pair) => pairComplete(pair) ? pair : [...state.scents]);
      state.message = 'Future deliveries are ready to customize.';
    } else {
      state.message = 'The same three kit scents will repeat for every delivery.';
    }
    invalidateAddedPlan();
    refreshAll();
  }));

  qs('[data-plan-theme-tabs]')?.addEventListener('click', (event) => {
    const button = event.target.closest('[data-plan-theme]');
    if (!button) return;
    selectKit(button.dataset.planTheme);
  });

  qs('[data-plan-advanced]')?.addEventListener('toggle', (event) => {
    state.advancedOpen = event.currentTarget.open;
    persist();
  });

  qs('[data-plan-primary-cta]')?.addEventListener('click', (event) => {
    if (state.step === 'scents') {
      setCurrentStep('plan', true);
    } else if (state.step === 'plan') {
      state.planConfirmed = true;
      setCurrentStep('review', true);
    } else if (readyForReview()) {
      startCheckout(event.currentTarget);
    }
  });

  const scentBackdrop = document.querySelector('[data-plan-scent-backdrop]');
  const slotBackdrop = document.querySelector('[data-plan-slot-backdrop]');
  let activeBackdrop = null;
  let returnFocus = null;

  const focusableElements = (dialog) => qsa('button:not(:disabled), [href], input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])', dialog);
  const showDialog = (backdrop, trigger) => {
    returnFocus = trigger || document.activeElement;
    activeBackdrop = backdrop;
    backdrop.removeAttribute('inert');
    backdrop.classList.add('show');
    backdrop.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const dialog = qs('[role="dialog"]', backdrop);
    requestAnimationFrame(() => (focusableElements(dialog)[0] || dialog).focus());
  };
  const closeDialog = (backdrop, restoreFocus = true) => {
    if (!backdrop) return;
    backdrop.classList.remove('show');
    backdrop.setAttribute('aria-hidden', 'true');
    backdrop.setAttribute('inert', '');
    document.body.style.overflow = '';
    activeBackdrop = null;
    const focusTarget = returnFocus;
    returnFocus = null;
    if (restoreFocus && focusTarget && document.contains(focusTarget)) focusTarget.focus();
  };

  function openKitDialog(theme, trigger) {
    const members = SCENTS.filter((s) => s.theme === theme);
    if (!members.length || !scentBackdrop) return;
    qs('[data-plan-kit-modal-theme]', scentBackdrop).textContent = 'ESSÉNCA SCENT KIT';
    qs('[data-plan-kit-modal-title]', scentBackdrop).textContent = theme;
    qs('[data-plan-kit-modal-sub]', scentBackdrop).textContent = `${members.length} essential oils · ${members.length} ScentPods per delivery`;
    const container = qs('[data-plan-kit-scents]', scentBackdrop);
    container.innerHTML = members.map((scent) => `
      <article class="plan-kit-scent">
        <div class="plan-kit-scent-image"><img src="${escapeHtml(imageUrls[scent.id] || '')}" alt="${escapeHtml(scent.name)}" loading="lazy" width="800" height="1000"></div>
        <div class="plan-kit-scent-body">
          <h3 class="plan-kit-scent-name">${scent.name}</h3>
          <p class="plan-kit-scent-desc">${scent.desc}</p>
          <dl class="plan-kit-scent-notes">
            <div><dt>Top notes</dt><dd>${scent.top}</dd></div>
            <div><dt>Heart notes</dt><dd>${scent.heart}</dd></div>
            <div><dt>Base notes</dt><dd>${scent.base}</dd></div>
          </dl>
          <p class="plan-kit-scent-ingredients"><span>Ingredients</span>${scent.ingredients || ''}</p>
        </div>
      </article>`).join('');
    const choice = qs('[data-plan-kit-modal-choice]', scentBackdrop);
    const selected = state.kit === theme;
    choice.textContent = selected ? 'Selected — choose another kit' : 'Select this kit';
    choice.classList.toggle('selected', selected);
    choice.setAttribute('aria-pressed', String(selected));
    choice.onclick = () => {
      if (state.kit !== theme) selectKit(theme);
      closeDialog(scentBackdrop);
    };
    showDialog(scentBackdrop, trigger);
  }

  function openSlotDialog(deliveryIndex, slotIndex, trigger) {
    resizeSchedule();
    const pair = state.schedule[deliveryIndex] || [null, null];
    qs('[data-plan-slot-title]', slotBackdrop).textContent = `Delivery ${deliveryIndex + 1}, bottle ${slotIndex + 1}`;
    const grid = qs('[data-plan-slot-grid]', slotBackdrop);
    grid.innerHTML = SCENTS.map((scent) => `<button type="button" class="plan-slot-option ${pair[slotIndex] === scent.id ? 'active' : ''}" data-plan-slot-option="${scent.id}" aria-pressed="${pair[slotIndex] === scent.id}"><span class="plan-slot-swatch" style="background:${scent.color}" aria-hidden="true"></span><span><strong>${scent.name}</strong><small>${scent.theme}</small></span></button>`).join('');
    qsa('[data-plan-slot-option]', grid).forEach((button) => button.addEventListener('click', () => {
      if (!state.schedule[deliveryIndex]) state.schedule[deliveryIndex] = [null, null];
      const currentPair = state.schedule[deliveryIndex];
      const scentId = button.dataset.planSlotOption;
      if (currentPair[1 - slotIndex] === scentId) currentPair[1 - slotIndex] = null;
      currentPair[slotIndex] = scentId;
      state.presetApplied = false;
      state.planConfirmed = false;
      state.message = pairComplete(currentPair) ? `Delivery ${deliveryIndex + 1} is complete.` : `Choose one more scent for Delivery ${deliveryIndex + 1}.`;
      closeDialog(slotBackdrop, false);
      invalidateAddedPlan();
      refreshAll();
      qs(`[data-plan-slot][data-delivery-index="${deliveryIndex}"][data-slot-index="${slotIndex}"]`)?.focus();
    }));
    showDialog(slotBackdrop, trigger);
  }

  qs('[data-plan-scent-close]', scentBackdrop)?.addEventListener('click', () => closeDialog(scentBackdrop));
  qs('[data-plan-slot-close]', slotBackdrop)?.addEventListener('click', () => closeDialog(slotBackdrop));
  [scentBackdrop, slotBackdrop].forEach((backdrop) => backdrop?.addEventListener('click', (event) => {
    if (event.target === backdrop) closeDialog(backdrop);
  }));

  document.addEventListener('keydown', (event) => {
    if (!activeBackdrop) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeDialog(activeBackdrop);
      return;
    }
    if (event.key !== 'Tab') return;
    const dialog = qs('[role="dialog"]', activeBackdrop);
    const focusable = focusableElements(dialog);
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (!first) {
      event.preventDefault();
      dialog.focus();
    } else if (!focusable.includes(document.activeElement)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  refreshAll();
})();
